import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  Renderer2,
  RendererStyleFlags2,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { FloatLabelType } from '@angular/material/form-field';
import { Option } from '@digilize/shared/definitions/src';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'lib-multi-select',
  templateUrl: './multi-select.component.html',
  styleUrls: ['./multi-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MultiSelectComponent implements OnInit {
  @Input() options: string[] | Option[] | any[] = [];
  @Input() control: FormControl;
  @Input() optionObj: boolean;
  @Input() selectedOptionObj: boolean;
  @Input() translation: boolean;
  @Input() translationPrefix: string;
  @Input() iconPath: string;
  @Input() openIconPath: string;
  @Input() myFloatLabel: FloatLabelType | 'never';
  @Input() placeholder = 'global.select';
  @Input() showTooltip = false;
  @Input() countChipsMode = false;
  @Input() onlyCounterMode = false;
  @Input() hideSelectedThreshold = 1;

  @Output() changed = new EventEmitter<any>();

  selectedChips = [];

  @HostListener('click')
  handleWrongOverlayPosition() {
    if (this.options?.length === 0) return;
    const overlayPane = document.querySelector('.cdk-overlay-pane');
    const flags = RendererStyleFlags2.DashCase | RendererStyleFlags2.Important;
    this.renderer.setStyle(overlayPane, 'transform', 'none', flags);
  }

  constructor(
    private renderer: Renderer2,
    private translocoService: TranslocoService
  ) {}

  ngOnInit(): void {
    this.selectedChips = this.control.value;
    this.control.valueChanges.subscribe((value: any) => {
      this.selectedChips = value;
    });
  }

  compareArrays(arr1: any, arr2: any): boolean {
    return arr1 && arr2 && arr1.id === arr2.id;
  }

  returnNull() {
    return null;
  }

  selected(option: string | Option) {
    this.changed.emit(option);
  }

  onChipRemoved(event, chip: string) {
    event.stopPropagation();
    const value = this.control.value;
    this.removeFirst(value, chip);
    // this.control.setValue(['']); // this one is required to to remove chips properly
    this.control.setValue(value); // To trigger change detection
    this.changed.emit(value);
  }

  private removeFirst(array: string[], toRemove: string): void {
    const index = array.indexOf(toRemove);
    if (index !== -1) {
      array.splice(index, 1);
    }
  }

  showWithPrefix(): boolean {
    return this.showTooltip && this.translation && !!this.translationPrefix;
  }
}
